import {
  REGISTER_USER,
  REGISTER_USER_SUCCESSFUL,
  REGISTER_USER_FAILED,
  REGISTER_API_ERROR,
} from "./actionTypes"
import { LOGOUT_USER_SUCCESS } from "../login/actionTypes"

const initialState = {
  registrationError: null,
  error: "",
  loading: false,
  message: null,
  user: null,
}

const account = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_USER:
      state = {
        ...state,
        loading: true,
        registrationError: null,
      }
      break
    case REGISTER_USER_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        user: action.payload,
        registrationError: null,
      }
      break
    case REGISTER_USER_FAILED:
      state = {
        ...state,
        user: null,
        loading: false,
        registrationError: action.payload,
      }
      break
    case "REGISTER_CLEAR_USER":
      // Clear the transient registration user so the Register page doesn't
      // auto-redirect if the user navigates back after a completed signup.
      state = { ...state, user: null, registrationError: null }
      break
    case REGISTER_API_ERROR:
      state = { ...state, error: action.payload || null, loading: false }
      break
    case "REGISTER_ERROR_CLEAR":
      state = { ...state, error: null }
      break
    case LOGOUT_USER_SUCCESS:
      // Clear registration state on logout so Register page doesn't auto-redirect
      state = { ...state, user: null, registrationError: null, loading: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default account
